var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTextIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19.541,
    height: 17.099,
    viewBox: "0 0 19.541 17.099",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 61772"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 44230",
    d: "M-4962.051-1055.224v-2.41h2.4v-12.226h-2.407v1.17h-2.437v-3.625h12.186v3.625h-2.413v-1.178h-2.425v12.217h2.4v2.426z",
    transform: "translate(4964.491 1072.314)",
    style: {}
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 44231",
    d: "M-4909.472-1030.909h1.173v-6.084h-1.194v1.174h-2.428v-3.628h9.743v3.629h-2.411V-1037h-1.221v6.08h1.183v2.444h-4.845z",
    transform: "translate(4921.718 1045.572)",
    style: {
      opacity: 0.6
    }
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTextIcon);
export default __webpack_public_path__ + "static/media/text-icon.1cfbb33fc1ca0607eaca4d044b5d60b8.svg";
export { ForwardRef as ReactComponent };